import { RootState } from "@/store/store";
import { oneTimeReportDetailsSelector } from "@/store/reports/selector/one-time/oneTimeReportDetailsSelector";

export const oneTimeReportDetailsIncludeAiSelector = (state: RootState) => {
  return !!oneTimeReportDetailsSelector(state)?.includeExplainAi;
};
